module.exports = __webpack_public_path__ + "static/jeff.f5286e86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/master_class/jeff.png
// module id = 571
// module chunks = 149428911916780